/* Estimación de envío interactiva. Actualiza todos los [data-shipping-eta] cada segundo,
   incluidos los re-renderizados por AJAX (carrito). Calcula:
   - Despacho (salida del almacén): hoy si es día hábil y antes del corte; si no, próximo día hábil.
   - Ventana de entrega: despacho + 1 a 3 días hábiles (24-72 h desde la salida del almacén).
   Tokens en los textos: %TIME% (cuenta atrás), %DATE% (despacho), %FROM% / %TO% (entrega). */
(function () {
  function madridNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' })); }
  function isBiz(d) { var g = d.getDay(); return g >= 1 && g <= 5; }
  function nextBiz(d) { var n = new Date(d); do { n.setDate(n.getDate() + 1); } while (!isBiz(n)); return n; }
  function addBiz(d, n) { var r = new Date(d), a = 0; while (a < n) { r.setDate(r.getDate() + 1); if (isBiz(r)) a++; } return r; }
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(d, loc) { return d.toLocaleDateString(loc, { weekday: 'long', day: 'numeric', month: 'long' }); }
  function render(el) {
    var out = el.querySelector('[data-shipping-eta-text]');
    if (!out) return;
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 11;
    var loc = el.getAttribute('data-locale') || 'es-ES';
    var tToday = el.getAttribute('data-today') || '';
    var tLater = el.getAttribute('data-later') || '';
    var now = madridNow();
    var dispatch, html;
    if (isBiz(now) && now.getHours() < cutoff) {
      dispatch = new Date(now);
      var c = new Date(now); c.setHours(cutoff, 0, 0, 0);
      var diff = c - now;
      var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
      html = tToday.replace('%TIME%', '<strong>' + h + 'h ' + p2(m) + 'm ' + p2(s) + 's</strong>');
    } else {
      dispatch = nextBiz(now);
      html = tLater.replace('%DATE%', '<strong>' + fmt(dispatch, loc) + '</strong>');
    }
    var from = addBiz(dispatch, 1), to = addBiz(dispatch, 3);
    html = html.replace('%FROM%', '<strong>' + fmt(from, loc) + '</strong>').replace('%TO%', '<strong>' + fmt(to, loc) + '</strong>');
    out.innerHTML = html;
    el.hidden = false;
  }
  function tick() {
    var els = document.querySelectorAll('[data-shipping-eta]');
    for (var i = 0; i < els.length; i++) render(els[i]);
  }
  function start() { tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
